

























































import {
  defineAsyncComponent, defineComponent, computed, watch, ref,
} from '@vue/composition-api';
import { ForceAgreement } from '@hb/coffee-widgets-agreement';
import { Tabs, TabItem } from '@hb/coffee';
import { contractsUrl } from '@/constant';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { TP_QUICK_WITHDRAW_CARD_AGREEMENT_POP } from '../../tianqi';

const defaultLogo:string = require('./images/logo.png');

// 兼容 vue2/vue3 方式
const ForceAgreementView = defineAsyncComponent(() => Promise.resolve(ForceAgreement.view));

export default defineComponent({
  name: 'ForceAgreementView_quick_withdraw',
  components: {
    Tabs,
    TabItem,
    ForceAgreementView,
  },
  props: {
    /** 是否展示该组件 */
    show: {
      type: Boolean,
      required: true,
    },
    /** 倒计时 */
    duration: {
      type: Number,
      default: 0,
    },
    /** 渠道数据 */
    data: {
      type: Array as () => Array<{
        capitalCode: string;
        productName: string;
        productIcon: string;
      }>,
      required: true,
    },
    /** 当前选中的资方协议列表 */
    contractList: {
      type: Array as () => any[],
      required: true,
    },
    /** 当前选中的资方索引 */
    currentCheckFundIndex: {
      type: Number,
      required: true,
    },
    /** 当前选中的协议索引 */
    currentContractIndex: {
      type: Number,
      required: true,
    },
    /** 是否属于部分放款渠道，true 是，false 否 */
    loanPartTag: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['changeTab', 'update:show', 'confirm'],
  setup(props, context) {
    // 防止关闭埋点重复执行
    const hasTriggeredCloseEvent = ref(false);

    const contract = computed(() => props.contractList.map((item) => ({
      name: item.name,
      contentUrl: item.url && item.url.includes('.pdf')
        ? `${contractsUrl || ''}?pdf_url=${item.url}`
        : item.url || '',
    })));

    /** 由于duration变成0时，强度弹窗重新挂在时还是进行了倒计时，所以需要根据duration动态设置forceReadScene的值
     * TODO: 此处实现需要组件库进行优化处理，目前的处理不合理@俊辉
     */
    const forceReadScene = computed(() => {
      const { duration } = props;
      if (duration > 0) {
        return ['COUNT_DOWN'];
      }
      return [];
    });

    /**
     * 切换渠道
     * @param index 选中的索引
     */
    const onHeaderTabChange = (index: number) => {
      context.emit('changeTab', index);
    };

    const changeContractIndex = (index: number) => {
      context.emit('changeContractIndex', index);
    };

    /**
     * 更新显示状态
     * @param value - 显示状态
     */
    const onUpdateShow = (value: boolean) => {
      // 当用户关闭弹窗时，触发关闭埋点
      // 需要在组件销毁前执行，因为父组件使用 v-if，组件会被立即销毁
      // 使用标志位防止重复执行（组件库可能触发多次 update:show 事件）
      if (!value && !hasTriggeredCloseEvent.value) {
        hasTriggeredCloseEvent.value = true;
        ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_AGREEMENT_POP, {
          Content: '关闭',
        });
      }
      context.emit('update:show', value);
    };

    const confirm = () => {
      ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_AGREEMENT_POP, {
        Content: '阅读全部协议',
      });
      context.emit('confirm');
    };

    // 监听弹窗显示状态，触发曝光埋点
    // 注意：关闭埋点在 onUpdateShow 中处理，因为父组件使用 v-if，组件销毁时 watch 可能来不及执行
    watch(
      () => props.show,
      (isVisible) => {
        if (isVisible) {
          // 重置关闭埋点标志位，允许下次打开时重新触发
          hasTriggeredCloseEvent.value = false;
          ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_AGREEMENT_POP);
        }
      },
      {
        immediate: true, // 组件创建时立即执行一次，因为父组件使用 v-if，组件创建时 show 已经是 true
      },
    );

    return {
      contract,
      forceReadScene,
      onHeaderTabChange,
      changeContractIndex,
      onUpdateShow,
      confirm,
      defaultLogo,
    };
  },
});
